ApiAjax = require 'app/scripts/network/api-ajax'
TrelloModel = require 'app/scripts/models/internal/trello-model'
log = require 'app/scripts/debug/log'

class Invitation extends TrelloModel
  typeName: 'Invitation'
  initialize: (attributes, options) ->
    log('invitation', options)
    @invitationList = options.collection

    @setReady()
    return

  # Temporary functions to handle invitations functions until backbone is migrated to new API
  create: ({ model, data, success, error }) ->
    ApiAjax
      url: "/1/#{ model.typeName }/#{ model.id }/invitations"
      type: 'post'
      data: data
      dataType: 'json'
      error: ([err]..., handler) =>
        if err.responseText.trim() == 'Member email restricted by organization administrators'
          # Email address did not match whitelist or board can't invite external members
          @$('.error').show()
          return
        unless err.responseText.trim() in ['Member already invited', 'Member already a member', 'Member email restricted by organization administrators']
          handler()
        error?(err)
      success: (data) =>
        success?(data)

  delete: ({ model, idInvitation, success, error }) ->
    ApiAjax
      url: "/1/#{ model.typeName }/#{ model.id }/invitations/#{ idInvitation }"
      type: 'delete'
      dataType: 'json'
      error: ([err]..., handler) =>
        unless err.responseText.trim() == 'Invitation not found'
          handler()
        error?(err)
      success: (data) =>
        success?(data)

  respond: ({ model, response, data, success, error }) ->
    ApiAjax
      url: "/1/#{ model.typeName }/#{ model.id }/invitations/#{ response }"
      type: 'post'
      dataType: 'json'
      data: data
      error: ([err]..., handler) =>
        unless err.responseText.trim() == 'already a member'
          handler()
        error?(err)
      success: (data) =>
        success?(data)

module.exports = Invitation
